module.exports = __webpack_public_path__ + "static/media/vts3.a91d8542.jpg";